import { useCallback, useContext, useEffect, useRef, useState } from "react";
import { PlayerContext } from "../../hooks/PlayerStore";
import axiosClient from "../../api/api";
import { Lyngonaut, NoLyrics, NoTrack } from "./Messages";

const Learn = () => {
  const player = useContext(PlayerContext);
  const [lyrics, setLyrics] = useState([]);
  const [status, setStatus] = useState("");
  const [currTimestamp, setCurrTimestamp] = useState(0);
  const timeoutRef = useRef(null);

  const fetchLyrics = useCallback(() => {
    axiosClient.get(`/track/lyrics/${player.track.id}`).then((response) => {
      if (response && response.status === 200) {
        if (response.data.status === "pending") {
          timeoutRef.current = setTimeout(() => {
            fetchLyrics();
          }, 3000);
        }

        setLyrics(response.data.lyrics);
        setStatus(response.data.status);
      }
    });
  }, [player.track.id]);

  useEffect(() => {
    if (!player.track.id) {
      return;
    }

    window.scrollTo(0, 0);
    fetchLyrics();

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [player.track.id, fetchLyrics]);

  useEffect(() => {
    if (!lyrics.length) {
      return;
    }
    const currentVerse = lyrics.findLast(
      (verse) => verse.timestamp <= player.progress
    );

    if (!currentVerse) {
      return;
    }

    setCurrTimestamp(currentVerse.timestamp);
  }, [player.progress, lyrics]);

  useEffect(() => {
    setLyrics([]);
  }, [player.track.id]);

  return (
    <>
      {player.track && player.track.title && (
        <div className="learn ps-2 ps-sm-4 text-md-center">
          <h1 className="song-title-outline text-light mt-1">
            {player.track.title}
          </h1>
          <h4 className="song-title-outline text-light  mb-4">
            <i>by</i> {player.track.artist}
          </h4>

          {lyrics &&
            lyrics.map((verse, index) => (
              <Verse
                key={index}
                verse={verse}
                currVerse={currTimestamp}
                skipTo={player.skipTo}
              />
            ))}
        </div>
      )}

      {status === "pending" && <Lyngonaut />}
      {(!player.track || !player.track.title) && <NoTrack />}
      {status === "not_found" && <NoLyrics />}
    </>
  );
};

const Verse = ({ verse, currVerse, skipTo }) => {
  let verseClass = "mb-4 verse";

  if (verse.timestamp === currVerse) {
    verseClass += " current";
  } else if (verse.timestamp < currVerse) {
    verseClass += " active";
  } else {
    verseClass += " new";
  }

  const ref = useRef();

  useEffect(() => {
    if (verse.timestamp === currVerse) {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currVerse]);

  return (
    <>
      <p
        ref={ref}
        className={verseClass}
        onClick={() => {
          skipTo(verse.timestamp);
        }}
      >
        <span className="d-block original mb-1">{verse.original}</span>
        {verse.translation !== "" && (
          <span className="d-block translation">{verse.translation}</span>
        )}
      </p>
    </>
  );
};

export default Learn;
